module.exports = __webpack_public_path__ + "media/images/pic/hero/land-96ebe7585d872a17421fbd2fcc1c27b8.png";